(function () {
  'use strict';

  function imageKey(src) {
    return String(src || '').replace(/^https?:/, '').split('?')[0]
      .replace(/_(?:\d+x\d*|x\d+)(?=\.[a-z]+$)/i, '');
  }

  function findImageIndex(images, image) {
    if (!image) return -1;
    var index = image.id == null ? -1 : images.findIndex(function (item) {
      return String(item.id) === String(image.id);
    });
    if (index !== -1 || !image.src) return index;
    return images.findIndex(function (item) { return imageKey(item.src) === imageKey(image.src); });
  }

  function colorVariant(variants, color, optionIndex, selectedId) {
    var matches = variants.filter(function (variant) {
      return (variant.options ? variant.options[optionIndex] : variant['option' + (optionIndex + 1)]) === color && variant.featured_image;
    });
    return matches.find(function (variant) { return String(variant.id) === String(selectedId); }) ||
      matches.find(function (variant) { return variant.available; }) || matches[0] || null;
  }

  function visibleRailOffset(left, width, itemLeft, itemWidth) {
    if (itemLeft < left) return itemLeft;
    if (itemLeft + itemWidth > left + width) return itemLeft + itemWidth - width;
    return left;
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { imageKey: imageKey, findImageIndex: findImageIndex,
      colorVariant: colorVariant, visibleRailOffset: visibleRailOffset };
    return;
  }
  if (window.csMobileProductGallery) return;

  function init() {
    var root = document.querySelector('.cs-product-detail');
    var mobile = root && root.querySelector('.cs-mobile-gallery');
    if (!mobile || !window.jQuery) return;
    var $gallery = window.jQuery(mobile.querySelector('.slider-for'));
    var rail = mobile.querySelector('.cs-mobile-gallery-rail');
    var thumbs = Array.from(rail.querySelectorAll('[data-image-index]'));
    // All color-bound main images remain available, but the rail only renders six.
    var images = Array.from(mobile.querySelectorAll('.slider-for .thumb.mobile-image')).map(function (slide) {
      var img = slide.querySelector('img');
      return { id: slide.dataset.imageId, src: img.getAttribute('data-original') ||
        img.getAttribute('data-cs-src') || img.getAttribute('src') };
    });
    var variants = window.productVariants || [];
    var viewport = window.matchMedia('(max-width: 768px)');
    var pendingIndex = -1;

    function syncThumb(index) {
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-current', i === index);
        thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      var thumb = thumbs[index];
      if (!thumb || !viewport.matches) return;
      var itemLeft = thumb.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
      rail.scrollLeft = visibleRailOffset(rail.scrollLeft, rail.clientWidth, itemLeft, thumb.offsetWidth);
    }

    function show(index) {
      if (!viewport.matches || index < 0 || index >= images.length) return false;
      pendingIndex = index;
      if (window.csShowProductGalleryImage) {
        if (!window.csShowProductGalleryImage($gallery[0], index)) return false;
        syncThumb(index);
        return true;
      }
      if (!$gallery.hasClass('slick-initialized')) return true;
      var slick = $gallery.slick('getSlick');
      // Instant positioning also handles rapid repeated color clicks during a fade.
      if (slick.currentSlide !== index) $gallery.slick('slickGoTo', index, true);
      syncThumb(index);
      return true;
    }

    function setVariant(variant) {
      var image = window.csResolveProductImage
        ? window.csResolveProductImage(variant) : variant && variant.featured_image;
      if (!window.csResolveProductImage && window.csShouldUseMobileVariant && !window.csShouldUseMobileVariant()) return false;
      return show(findImageIndex(images, image));
    }

    window.csMobileProductGallery = { setVariant: setVariant };
    $gallery.on('init.csMobileGallery reInit.csMobileGallery', function (event, slick) {
      // The hidden desktop gallery keeps its original navigation. Mobile uses
      // its own fixed six-thumbnail rail instead of the shared global Slick selectors.
      slick.options.asNavFor = null;
      slick.originalSettings.asNavFor = null;
      syncThumb(slick.currentSlide);
      // Slick dispatches init before assigning element.slick; wait for that assignment.
      if (pendingIndex >= 0) Promise.resolve().then(function () { show(pendingIndex); });
    }).on('afterChange.csMobileGallery', function (event, slick, index) {
      pendingIndex = index;
      syncThumb(index);
    });
    if ($gallery.hasClass('slick-initialized')) $gallery.slick('getSlick').options.asNavFor = null;

    mobile.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-image-index]');
      var arrow = event.target.closest('[data-gallery-scroll]');
      if (!viewport.matches || (!thumb && !arrow)) return;
      event.preventDefault();
      if (thumb) show(Number(thumb.dataset.imageIndex));
      else rail.scrollBy({ left: rail.clientWidth * Number(arrow.dataset.galleryScroll),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });

    window.jQuery(root).on('change.csMobileGallery', '.swatch-element.color input[type="radio"]', function (event) {
      var input = event.target;
      if (!viewport.matches || !input.matches('.swatch-element.color input[type="radio"]')) return;
      var optionIndex = Number(input.closest('.swatch').dataset.optionIndex);
      if (optionIndex === 0 && window.csUpdateRecommendationColor) {
        window.csUpdateRecommendationColor(input.value);
      }
      // Let existing variant/price/size handlers finish; no network request or delay.
      Promise.resolve().then(function () {
        var selected = root.querySelector('#product-selectors');
        setVariant(colorVariant(variants, input.value, optionIndex, selected && selected.value));
      });
    });
    viewport.addEventListener('change', function () {
      if (viewport.matches && $gallery.hasClass('slick-initialized')) {
        $gallery.slick('setPosition');
        var currentIndex = $gallery.slick('getSlick').currentSlide;
        show(window.csShowProductGalleryImage || pendingIndex < 0 ? currentIndex : pendingIndex);
      }
    });
    var initialId = window.csProductEntryVariantId;
    var initial = variants.find(function (variant) {
      return String(variant.id) === String(initialId);
    }) || window.csPendingMobileVariant;
    if (!setVariant(initial)) syncThumb(0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
